import React from 'react';

function Footer() {
  return (
    <footer style={{
      background: '#cb6343ef',
      color: '#fff',
      padding: '1rem 0',
      textAlign: 'center',
      marginTop: '2rem',
      position: 'relative',
      bottom: 0,
      width: '100%',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div style={{ marginLeft: '2rem' }}>
        Copyright &copy; {new Date().getFullYear()} myastrolabs.com - All Rights Reserved.
      </div>
      {/* <div style={{ marginRight: '2rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
         <a
          href="/AcharyaPaththathi-1.0.8-release.apk"
          download
          style={{ display: 'flex', alignItems: 'center', color: '#fff', textDecoration: 'none', gap: '8px' }}
        >
        <i className="bi bi-android2" style={{ fontSize: '1.7rem', color: '#fff' }}></i>
        <span>Download our App</span>
        </a>
      </div> */}
    </footer>
  );
}

export default Footer;
